module.exports = {"apiURL":"https://dev.api.veloe.com.br","apiURLVeloe":"https://dev.api.veloe.com.br","apiAuthorization":"Basic Q3VzdG9tZXJDbGllbnQ6ZW9CWDYxaWc4Z0plTnVaRHpH","apiAuthorizationC6":"Basic UGFyY2Vpcm8tYzY6MlkhZlRlY0pOWmdScEJmbjJaa1pSJCZmeWp0NCFU","publicSite":"http://dev.fastalelo.com","brasPagURL":"https://transactionsandbox.pagador.com.br/post/api/public/v1","pfURL":"http://minha-veloe-pf-dev.s3-website-us-east-1.amazonaws.com","buildNumber":"1687543219522","authScope":"Customer.Info"}


//////////////////
// WEBPACK FOOTER
// ./src/alelo-logic/config.json
// module id = 221
// module chunks = 0